var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cf-node-properties__input" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "on-clickaway",
            rawName: "v-on-clickaway",
            value: _vm.away,
            expression: "away"
          }
        ],
        staticClass: "voice-selector"
      },
      [
        _c(
          "span",
          {
            staticClass:
              "btn btn-default form-control voice-selector__search-toggle",
            on: { click: _vm.toggleInput }
          },
          [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selectedVoice,
                    expression: "selectedVoice"
                  }
                ]
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.selectedVoiceFormattedName) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("i", { staticClass: "caret" })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.inputEnabled,
                expression: "inputEnabled"
              }
            ],
            staticClass: "voice-selector__explore-container"
          },
          [
            _c(
              "Tabs",
              {
                staticClass: "voice-selector__tabs-container",
                attrs: { "custom-nav-class": "nav-stacked" },
                model: {
                  value: _vm.activeTab,
                  callback: function($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab"
                }
              },
              [
                _c("Tab", { attrs: { title: _vm.$t("MALE"), index: "0" } }, [
                  _c(
                    "div",
                    { staticClass: "voice-selector__tree" },
                    _vm._l(
                      _vm.voices.filter(voice => voice.gender === "Male"),
                      function(voice) {
                        return _c(
                          "div",
                          {
                            key: voice.voiceId,
                            staticClass: "voice-selector__tree-gender"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "voice-name",
                                class: {
                                  active:
                                    _vm.selectedVoice.voiceId === voice.voiceId
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.selectVoice(voice)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(voice.name) +
                                    "\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.samplePaused && voice.sample
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn btn-function right m-t-5 m-r-20",
                                    attrs: { href: "javascript:void(0);" },
                                    on: {
                                      click: function($event) {
                                        return _vm.play(voice.sample)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-volume-down"
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.samplePaused && voice.sample
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn btn-function right m-t-5 m-r-20",
                                    attrs: { href: "javascript:void(0);" },
                                    on: {
                                      click: function($event) {
                                        return _vm.pause(voice.sample)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa",
                                      class: {
                                        "fa-volume-down":
                                          _vm.sample.src !== voice.sample,
                                        "fa-pause":
                                          _vm.sample.src === voice.sample
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      }
                    ),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("Tab", { attrs: { index: 1, title: _vm.$t("FEMALE") } }, [
                  _c(
                    "div",
                    { staticClass: "voice-selector__tree" },
                    _vm._l(
                      _vm.voices.filter(voice => voice.gender === "Female"),
                      function(voice) {
                        return _c(
                          "div",
                          {
                            key: voice.voiceId,
                            staticClass: "voice-selector__tree-gender"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "voice-name",
                                class: {
                                  active:
                                    _vm.selectedVoice.voiceId === voice.voiceId
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.selectVoice(voice)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(voice.name) +
                                    "\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.samplePaused && voice.sample
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn btn-function right m-t-5 m-r-20",
                                    attrs: { href: "javascript:void(0);" },
                                    on: {
                                      click: function($event) {
                                        return _vm.play(voice.sample)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-volume-down"
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.samplePaused && voice.sample
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn btn-function right m-t-5 m-r-20",
                                    attrs: { href: "javascript:void(0);" },
                                    on: {
                                      click: function($event) {
                                        return _vm.pause(voice.sample)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa",
                                      class: {
                                        "fa-volume-down":
                                          _vm.sample.src !== voice.sample,
                                        "fa-pause":
                                          _vm.sample.src === voice.sample
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      }
                    ),
                    0
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _vm.errorMessage
      ? _c("div", { staticClass: "cf-node-properties__input-error" }, [
          _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }